import { Colors } from "../constants/colors";
import { miscStyles } from "./styles";

export default {
  styleOverrides: {
    root: {
      ...miscStyles.buttonDefault,
      boxShadow: "none",
      border: "1px solid transparent",
      padding: "6px 16px",
      borderRadius: 4,
      gap: "4px",
      "& .MuiButton-startIcon": {
        width: "18px",
        height: "18px",
        marginRight: "0px",
        "& .MuiSvgIcon-root": {
          width: "18px",
          height: "18px",
        },
      },
      "& .MuiButton-endIcon": {
        width: "18px",
        height: "18px",
        marginLeft: "0px",
        "& .MuiSvgIcon-root": {
          width: "18px",
          height: "18px",
        },
      },
      "&:hover": {
        boxShadow: "none",
      },
      ":disabled": {
        color: Colors.GREY300,
        backgroundColor: Colors.GREY250,
        "& .MuiTypography-root": {
          color: Colors.GREY300,
        },
      },
    },
  },
  variants: [
    {
      props: { variant: "primary" },
      style: {
        color: Colors.WHITE,
        backgroundColor: Colors.GREY500,
        "& .MuiTypography-root": {
          color: Colors.WHITE,
        },
        "&:hover": {
          color: Colors.GREY500,
          backgroundColor: Colors.WHITE,
          border: `1px solid ${Colors.GREY500}`,
          "& .MuiTypography-root": {
            color: Colors.GREY500,
          },
        },
        ":disabled": {
          color: Colors.GREY350,
          //This color is custom for disable state and is present in figma design
          backgroundColor: "#F2F2F3",
          "& .MuiTypography-root": {
            color: Colors.GREY350,
          },
        },
      },
    },
    {
      props: { variant: "secondary" },
      style: {
        color: Colors.GREY500,
        backgroundColor: Colors.WHITE,
        border: `1px solid ${Colors.GREY300}`,
        "&:hover": {
          color: Colors.GREY500,
          backgroundColor: Colors.GREY100,
          border: `1px solid ${Colors.GREY400}`,
        },
        ":disabled": {
          color: Colors.GREY350,
          backgroundColor: Colors.WHITE,
          border: `1px solid ${Colors.GREY250}`,
          "& .MuiTypography-root": {
            color: Colors.GREY350,
          },
        },
      },
    },
    {
      props: { variant: "utility" },
      style: {
        color: Colors.GREY500,
        backgroundColor: Colors.GREY100,
        "&:hover": {
          color: Colors.GREY500,
          backgroundColor: Colors.GREY200,
        },
        ":disabled": {
          color: Colors.GREY350,
          backgroundColor: Colors.GREY100,
          "& .MuiTypography-root": {
            color: Colors.GREY350,
          },
        },
      },
    },
    {
      props: { variant: "text-link" },
      style: {
        color: Colors.BLUE500,
        padding: "0px 5px",
        border: "0px",
        "&:hover": {
          backgroundColor: "transparent",
        },
        ":disabled": {
          backgroundColor: "transparent",
          color: Colors.GREY350,
        },
      },
    },
    //we removed the "text-link-bordered" variant and replace the usage with "secondary" variant
    //we removed the "hovered" variant and replace the usage with "primary" variant
    //we removed the "ey-disabled" variant and replace the usage with "primary" variant
    //we removed the "utility-bordered" variant and replace the usage with "secondary" variant
    //we removed the "white" variant and replace the usage with "primary" variant
    //we removed the "text-link-secondary" variant and replace the usage with "utility" variant
  ],
};
